import { CustomerTable } from "../../component/CustomerTable.js";

export default function CutomersPaymentsPage() {
  return <CustomerTable />;
}
